<template>
  <Card>
    <RadioGroup v-model="tabName" type="button" button-style="solid">
      <Radio :label="tabs[0]">{{ $t('configuration.sourceConfKeys') }}</Radio>
      <Radio :label="tabs[1]">{{ $t('configuration.sinkTemplates') }}</Radio>
    </RadioGroup>

    <SourceConfKeys v-if="tabName === tabs[0]" :confKeyList="confKeyListJSON.sources" @reload="getAllConfKeyList" />
    <SinkConfKeys v-if="tabName === tabs[1]" :confKeyList="confKeyListJSON.sinks" @reload="getAllConfKeyList" />
  </Card>
</template>

<script>
import nodeID from '@/mixins/nodeID'
import { getConfigKeyResources } from '@/api/metadata'
import SourceConfKeys from './SourceConfKeys.vue'
import SinkConfKeys from './SinkConfKeys.vue'

export default {
  name: 'Resources',
  mixins: [nodeID],

  components: {
    SourceConfKeys,
    SinkConfKeys,
  },

  data() {
    return {
      tabName: 'source',
      tabs: ['source', 'sink'],
      confKeyListJSON: {
        sources: [],
        sinks: [],
      },
    }
  },

  created() {
    this.getAllConfKeyList()
  },

  methods: {
    // get all conf keys
    getAllConfKeyList() {
      getConfigKeyResources(this.nodeID).then((res) => {
        const { data } = res
        const typeValues = data ? Object.entries(data) : []

        if (!typeValues.length) {
          return
        }

        typeValues.forEach(([type, values]) => {
          let confKeyList = []
          const confKeyValues = values || []

          confKeyValues.forEach((value) => {
            const confKeys = Object.keys(value)
            confKeys.forEach((confKey) => {
              const keyItem = {}
              keyItem.name = confKey
              keyItem.type = value[confKey]
              confKeyList = [...confKeyList, keyItem]
            })
          })

          this.confKeyListJSON[type] = confKeyList
        })
      })
    },
  },
}
</script>
